import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import { useParams } from 'react-router-dom'
import { Modal } from 'react-responsive-modal'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import Loading from '../../components/Loading'
import AdminMapBlock from '../../components/AdminMapBlock'

export default () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [editingMarker, setEditingMarker] = useState<string>('')
  const [modalRemove, setModalRemove] = useState<boolean>(false)
  const [removeMarkerId, setRemoveMarkerId] = useState<string>('')

  const { map_id } = useParams<{ map_id: string }>()
  const dispatch = useDispatch()

  const isMounted = useRef<boolean>(false)
  const refUpload = useRef<HTMLInputElement | null>(null)

  const {
    map,
    course,
    isProcessFetching,
    isProcessFetchingCourse,
    isProcessEditMap,
    error,
  } = useSelector((state: { adminMapEdit: InitialState }) => state.adminMapEdit)

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchMap(map_id))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (map && isMounted.current && !isLoaded) {
      dispatch(actions.fetchCourse(map.course_id))
    }
  }, [map, isMounted])

  useEffect(() => {
    if (course && isMounted.current) {
      setIsLoaded(true)
    }
  }, [course])

  useEffect(() => {
    if (!isProcessFetching && editingMarker) {
      setEditingMarker('')
    }
  }, [isProcessFetching])

  const modalStyles = {
    root: {
      zIndex: 99999,
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.4)',
    },
    modal: {
      width: 250,
      borderRadius: 10,
      padding: 20,
      margin: '2em',
      boxShadow: 'unset',
      overflow: 'unset',
      outline: 0,
    },
  }

  const onChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && map) {
      const file = event.target.files[0]
      dispatch(actions.editMap(map_id, map.course_id, file))
    }
  }

  const handleOpenPicker = () => {
    if (refUpload.current) {
      refUpload.current?.click()
    }
  }

  const handleCreateMarker = (module_lesson_id: string) => {
    if (map) {
      dispatch(
        actions.createMarker(map.map_id, 'circle', 0, 0, module_lesson_id)
      )
    }
  }

  const handleEditMarker = (marker_id: string, type: string) => {
    if (map) {
      setEditingMarker(marker_id)
      dispatch(actions.editMarker(map.map_id, marker_id, type))
    }
  }

  const handleEditStatus = (value: string) => {
    if (map) {
      dispatch(actions.editMap(map_id, map.course_id, undefined, value))
    }
  }

  const handleReplaceMarker = (
    marker_id: string,
    left: number,
    top: number
  ) => {
    if (map) {
      dispatch(actions.editMarker(map.map_id, marker_id, undefined, left, top))
    }
  }

  const handleRemoveMarker = () => {
    if (removeMarkerId && map) {
      dispatch(actions.removeMarker(map.map_id, removeMarkerId))
      setRemoveMarkerId('')
      setModalRemove(false)
    }
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {(!isMounted.current ||
          isProcessFetching ||
          isProcessFetchingCourse ||
          !map ||
          !course) &&
        !isLoaded ? (
          <LoadingPage />
        ) : map ? (
          <>
            <h2>Панель администрирования - Редактирование карты</h2>
            {map.image_media && course ? (
              <AdminMapBlock
                image={map.image_media.url}
                title={'Настройка карты'}
                markers={map.markers}
                modules={course.modules}
                themes={course.themes}
                onReplaceMarker={handleReplaceMarker}
                onRemoveMarker={marker_id => {
                  setRemoveMarkerId(marker_id)
                  setModalRemove(true)
                }}
              />
            ) : null}
            <br />
            <label>Статус карты:</label>
            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <select
                onChange={event => handleEditStatus(event.target.value)}
                value={map.is_active ? '1' : '0'}
              >
                <option value={'1'}>Активна</option>
                <option value={'0'}>Не активна</option>
              </select>
              {isProcessEditMap ? (
                <Loading
                  color={'#1978B2'}
                  width={15}
                  height={15}
                  style={{
                    margin: '5px 0 0 10px',
                    display: 'block',
                  }}
                />
              ) : null}
            </div>
            <button onClick={handleOpenPicker} style={{ marginTop: 10 }}>
              Изменить файл карты
            </button>
            <input
              ref={refUpload}
              style={{ display: 'none' }}
              type={'file'}
              onChange={onChangeFile}
            />
            <br />
            <br />
            {course ? (
              <>
                <h3>Модули:</h3>
                <ul style={{ margin: '0 0 40px', padding: '0 20px' }}>
                  {course.modules.map(module => (
                    <li key={module.module_id}>
                      {module.title}
                      {module.module_lessons && module.module_lessons.length ? (
                        <ul>
                          {module.module_lessons
                            .sort((a, b) => a.position - b.position)
                            .map(moduleLesson => {
                              const marker = map.markers.find(
                                marker =>
                                  marker.module_lesson_id ===
                                  moduleLesson.module_lesson_id
                              )

                              return (
                                <li
                                  style={{
                                    margin: '7px 0',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                  }}
                                  key={moduleLesson.lesson_id}
                                >
                                  {moduleLesson.lesson.title}{' '}
                                  <button
                                    style={{ marginLeft: 10, marginRight: 10 }}
                                    disabled={!!marker}
                                    onClick={() =>
                                      handleCreateMarker(
                                        moduleLesson.module_lesson_id
                                      )
                                    }
                                  >
                                    Добавить на карту
                                  </button>
                                  {marker ? (
                                    <select
                                      value={marker?.type}
                                      style={{ width: 150 }}
                                      onChange={value =>
                                        marker
                                          ? handleEditMarker(
                                              marker.marker_id,
                                              value.target.value
                                            )
                                          : null
                                      }
                                    >
                                      <option value={'circle'}>Круг</option>
                                      <option value={'oval'}>Овал</option>
                                      <option value={'rectangle'}>
                                        Прямоугольник
                                      </option>
                                      <option value={'clover'}>Клевер</option>
                                      <option value={'rhombus'}>Ромб</option>
                                      <option value={'hexagon'}>
                                        Шестиугольник
                                      </option>
                                      <option value={'concave_cylinder'}>
                                        Вогнутый цилиндр
                                      </option>
                                      <option value={'rounded_rectangle'}>
                                        Скругленный прямоугольник
                                      </option>
                                    </select>
                                  ) : null}
                                  {marker &&
                                  marker.marker_id === editingMarker ? (
                                    <Loading
                                      color={'#1978B2'}
                                      width={15}
                                      height={15}
                                      style={{
                                        margin: '5px 0 0 10px',
                                        display: 'block',
                                      }}
                                    />
                                  ) : null}
                                </li>
                              )
                            })}
                        </ul>
                      ) : null}
                    </li>
                  ))}
                </ul>
                <button
                  disabled={
                    !!map.markers.find(marker => marker.type === 'start')
                  }
                  style={{ marginBottom: 10 }}
                  onClick={() =>
                    dispatch(actions.createMarker(map.map_id, 'start', 0, 0))
                  }
                >
                  Разместить флаг старта на карту
                </button>
                <br />
                <button
                  disabled={
                    !!map.markers.find(marker => marker.type === 'finish')
                  }
                  onClick={() =>
                    dispatch(actions.createMarker(map.map_id, 'finish', 0, 0))
                  }
                  style={{ marginBottom: 30 }}
                >
                  Разместить флаг финиша на карту
                </button>
              </>
            ) : null}
          </>
        ) : null}
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
        <Modal
          open={modalRemove}
          showCloseIcon={false}
          onClose={() => setModalRemove(false)}
          styles={modalStyles}
          center={true}
        >
          <>
            <h3 style={{ marginTop: 0 }}>
              Вы уверены, что хотите удалить этот маркер?
            </h3>
            <button style={{ width: 50 }} onClick={handleRemoveMarker}>
              Да
            </button>{' '}
            &nbsp;
            <button style={{ width: 50 }} onClick={() => setModalRemove(false)}>
              Нет
            </button>
          </>
        </Modal>
      </div>
      <Footer />
    </>
  )
}
